/**
 * util function to tell if email is valid or not
 * @param {string} email email string
 * @returns {boolean} if email is good or not
 */
export const isEmailValid = (email) => {
  /* eslint-disable no-useless-escape */
  const re = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  /* eslint-enable no-useless-escape */
  return re.test(email.toLowerCase());
}